/**
 * @swagger http://rests.afisha.ru/rests/api/owner/v1/swagger/
 */

import { apiOwnerMock } from './apiOwnerMock'

import * as Types from '@shared/api/types/apiOwnerParameters'
import { apiRequest } from '@shared/api/apiRequest'
import { mappingAPIowner } from '@shared/api/middleware/mappingAPI'
import { middlewareError, textErrorsApiOwner } from '@shared/api/middleware/middlewareError'
// import { globalStore } from '@app/model/store'
// import { closeBooking } from '@widgets/Restaurant/Booking'

const BASE_DOMAIN = process.env.IS_STAGE === 'true' ? 'https://artemis.dev.rests.afisha.ru' : 'https://www.afisha.ru'
const BASE_URL = `${BASE_DOMAIN}/rests/api/owner/v1`
const GITLAB_STATUS = process.env.GITLAB_STATUS
const IS_PROD = GITLAB_STATUS === '0'

export const API_OWNER = {
  // *** endpoints section: API FILES ***

  api_files_list: (props: Types.PropsApiFilesList) => {
    return mappingAPIowner
      .api_files_list(apiRequest.get({ url: `${BASE_URL}/api_files/`, ...props }))
      .catch(() => middlewareError('api_files_list', props, { isThrowException: false }))
  },

  api_files_create: async (props: Types.PropsApiFilesCreate) => {
    // Бекенд ждет файл в формате formData
    // Доп функции ниже также нужны для случая если в props.body.file будет передан url blob вида: blob:https://localhost:80/50992bdc-9385-4664-b63e-99525d20aee2
    const blob = await fetch(props.body.file).then((r) => r.blob())
    const formData = new FormData()
    formData.append('file', blob, 'Cropper.jpg')

    const modifiedProps = { ...props, body: formData }

    return mappingAPIowner
      .api_files_create(apiRequest.post({ url: `${BASE_URL}/api_files/`, ...modifiedProps }))
      .catch(() => middlewareError('api_files_create', props))
  },

  api_files_read: (props: Types.PropsApiFilesRead) => {
    return mappingAPIowner
      .api_files_read(apiRequest.get({ url: `${BASE_URL}/api_files/${props.id}/`, ...props }))
      .catch(() => middlewareError('api_files_read', props, { isThrowException: false }))
  },

  api_files_delete: (props: Types.PropsApiFilesDelete) => {
    return mappingAPIowner
      .api_files_delete(apiRequest.delete({ url: `${BASE_URL}/api_files/${props.id}/`, ...props }))
      .catch(() => middlewareError('api_files_delete', props, { isThrowException: false }))
  },

  // *** endpoints section: R ***

  r_read: (props: Types.PropsRRead) => {
    const thisMock = apiOwnerMock['r_read']
    return mappingAPIowner
      .r_read(
        IS_PROD
          ? apiRequest.get({ url: `${BASE_URL}/r/${props.rid}/`, ...props })
          : new Promise((resolve, reject) => {
              resolve(thisMock)
            }),
      )
      .catch(() => middlewareError('r_read', props, { isThrowException: false }))
  },

  r_read_stat: (props: Types.PropsReadStat) => {
    const thisMock = apiOwnerMock['r_read_stat']
    return mappingAPIowner
      .r_read_stat(
        IS_PROD
          ? // @ts-ignore
            apiRequest.get({ url: `${BASE_URL}/r/${props.params.rid}/stat/real/`, ...props })
          : new Promise((resolve, reject) => {
              resolve(thisMock)
            }),
      )
      .catch(() => middlewareError('r_read_stat', props, { isThrowException: false }))
  },

  r_info: (props: Types.PropsRInfo) => {
    const thisMock = apiOwnerMock['r_info']
    return mappingAPIowner
      .r_info(
        IS_PROD
          ? apiRequest.patch({ url: `${BASE_URL}/r/${props.rid}/info/?restaurant=${props.restaurant}`, ...props })
          : new Promise((resolve, reject) => {
              resolve(thisMock)
            }),
      )
      .catch(() => middlewareError('r_info', props, { isThrowException: false }))
  },

  r_menu_partial_update: (props: Types.PropsRMenuPartialUpdate) => {
    return mappingAPIowner
      .r_menu_partial_update(
        apiRequest.patch({
          url: `${BASE_URL}/r/${props.rid}/menu/${props.id}/`,
          ...props,
        }),
      )
      .catch(() => middlewareError('r_menu_partial_update', props))
  },

  r_menu_item_create: (props: Types.PropsRMenuItemCreate) => {
    return mappingAPIowner
      .r_menu_item_create(
        apiRequest.post({
          url: `${BASE_URL}/r/${props.rid}/menu/${props.menu_offer_id}/item/`,
          ...props,
        }),
      )
      .catch(() => middlewareError('r_menu_item_create', props))
  },

  r_menu_item_partial_update: (props: Types.PropsRMenuItemPartialUpdate) => {
    return mappingAPIowner
      .r_menu_item_partial_update(
        apiRequest.patch({
          url: `${BASE_URL}/r/${props.rid}/menu/${props.menu_offer_id}/item/${props.id}/?restaurant=${props.restaurant}`,
          ...props,
        }),
      )
      .catch(() => middlewareError('r_menu_item_partial_update', props))
  },

  r_menu_item_delete: (props: Types.PropsRMenuItemDelete) => {
    return mappingAPIowner
      .r_menu_item_delete(
        apiRequest.delete({
          url: `${BASE_URL}/r/${props.rid}/menu/${props.menu_offer_id}/item/${props.id}/`,
          ...props,
        }),
      )
      .catch(() => middlewareError('r_menu_item_delete', props))
  },

  r_news_partial_update: (props: Types.PropsRNewsPartialUpdate) => {
    return mappingAPIowner
      .r_news_partial_update(
        apiRequest.patch({
          url: `${BASE_URL}/r/${props.rid}/news/${props.id}/`,
          ...props,
        }),
      )
      .catch(() => middlewareError('r_news_partial_update', props))
  },

  r_special_partial_update: (props: Types.PropsRSpecialPartialUpdate) => {
    return mappingAPIowner
      .r_special_partial_update(
        apiRequest.patch({
          url: `${BASE_URL}/r/${props.rid}/special/${props.id}/?restaurant=${props.restaurant}`,
          ...props,
        }),
      )
      .catch(() => middlewareError('r_special_partial_update', props))
  },

  // *** endpoints section: OWNER REVIEWS ***

  owner_reviews_list: (props: Types.PropsOwnerReviewsList) => {
    const thisMock = apiOwnerMock['owner_reviews_list'](props)

    return mappingAPIowner
      .owner_reviews_list(
        IS_PROD
          ? apiRequest.get({ url: `${BASE_URL}/reviews/`, ...props })
          : new Promise((resolve, reject) => {
              resolve(thisMock)
            }),
      )
      .catch(() => middlewareError('owner_reviews_list', props, { isThrowException: false }))
  },

  owner_reviews_read: (props: Types.PropsOwnerReviewsRead) => {
    return mappingAPIowner
      .owner_reviews_read(apiRequest.get({ url: `${BASE_URL}/reviews/${props.id}/`, ...props }))
      .catch(() => middlewareError('owner_reviews_read', props, { isThrowException: false }))
  },

  owner_reviews_partial_update: (props: Types.PropsOwnerReviewsPartialUpdate) => {
    const thisMock = apiOwnerMock['owner_reviews_partial_update']
    return mappingAPIowner
      .owner_reviews_partial_update(
        IS_PROD
          ? apiRequest.patch({ url: `${BASE_URL}/reviews/${props.id}/?restaurant=${props.restaurant}`, ...props })
          : new Promise((resolve, reject) => resolve(thisMock)),
      )
      .catch(() => {
        middlewareError('owner_reviews_partial_update', props)
      })
  },
}
